import { getPoLineArrivedQuantity, poLineDidNotArrive } from './poLineQuantity';

export const HIGH_PO_LABEL_QUANTITY_THRESHOLD = 20;

export const normalisePoLabelQuantity = (value) => {
  const quantity = Number.parseInt(value, 10);
  return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
};

const hasPrintableSku = (item) => String(item?.sku || item?.variant_sku || '').trim().length > 0;

export const getMaxPoLineLabelQuantity = (po) => {
  const items = Array.isArray(po?.items)
    ? po.items
    : Array.isArray(po?.line_items)
      ? po.line_items
      : [];

  // Counted against what actually arrived — the delivery is what gets labelled.
  return items.reduce((max, item) => (
    hasPrintableSku(item) && !poLineDidNotArrive(item)
      ? Math.max(max, normalisePoLabelQuantity(getPoLineArrivedQuantity(item)))
      : max
  ), 0);
};

export const poNeedsLabelGridReview = (po, threshold = HIGH_PO_LABEL_QUANTITY_THRESHOLD) => {
  const guardThreshold = Math.max(1, normalisePoLabelQuantity(threshold));
  return getMaxPoLineLabelQuantity(po) >= guardThreshold;
};

export const buildHighQuantityPoLabelTaskOverride = (po) => {
  if (!poNeedsLabelGridReview(po)) return undefined;

  const maxQuantity = getMaxPoLineLabelQuantity(po);
  return {
    printLabels: {
      label: '2. Load in Grid',
      shortLabel: '2. Load in Grid',
      description: `This PO has a line with ${maxQuantity} labels. Load it into Products, check quantities, print labels, then return here and tick Step 2.`,
      actionType: 'loadLabelsInGrid',
      actionLabel: 'Load in Grid',
      allowManualComplete: true
    }
  };
};
